/* eslint-disable react-hooks/rules-of-hooks */
import { createSlice } from "@reduxjs/toolkit";
import {
  showNavigation,
  showNavigationDictionary,
} from "../actions/navigation";

const initialState = {
  navigation: [],
};
const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {},
  extraReducers: {
    // show
    [showNavigation.fulfilled]: (state, action) => {
      state.navigation = action.payload;
      
    },
    [showNavigationDictionary.fulfilled]: (state, action) => {
      state.navigation = action.payload;
    },
  },
});

export const responseNavigation = (state) => state.navigation;

export default navigationSlice.reducer;
